// @flow
import type {Element} from 'react'
import React from 'react'

// eslint-disable-next-line import/named
import Alert, {Severity} from 'components/ui/Alert'
import styles from '../index.scss'

type Props = $ReadOnly<{
  section: any,
}>

function ItalicizedTitle({section}: Props): Element<"div"> {
  return (
    <div className={styles.italicizedTitle}>
      <Alert
        centered
        message={section.title}
        severity={Severity.Info}
      />
    </div>
  )
}

export default ItalicizedTitle
